import { Fragment } from 'react';

import filterMap from './filters';

function Filter(props) {
    const { type, context } = props;

    let FilterComponent = null;

    if (context.config && context.config.customFilters && context.config.customFilters[type]) {
        FilterComponent = context.config.customFilters[type];
    } else {
        if (filterMap[type]) {
            FilterComponent = filterMap[type];
        }
    }

    if (!FilterComponent) return <Fragment />;

    return <FilterComponent {...props} />;
}

export default Filter;
